import { useEffect, useState } from "react";
import { RefreshCw, Mail, CheckCircle2, Circle } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminContactos() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/contactos");
      setItems(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toggleResolved = async (id) => {
    try {
      const { data } = await api.patch(`/admin/contactos/${id}`);
      setItems((arr) => arr.map((c) => (c.id === id ? { ...c, resolvido: data.resolvido } : c)));
      toast.success(data.resolvido ? "Marcado como resolvido." : "Marcado como pendente.");
    } catch (_e) {
      toast.error("Não foi possível atualizar.");
    }
  };

  return (
    <div data-testid="admin-contactos-page">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold">Contactos</h1>
          <p className="text-sm text-[var(--ldr-text-muted)] mt-1">
            Mensagens submetidas em /contactos.
          </p>
        </div>
        <button type="button" onClick={load} className="ldr-btn-outline" data-testid="admin-contactos-refresh">
          <RefreshCw size={14} /> Atualizar
        </button>
      </div>

      <div className="ldr-card">
        {loading ? (
          <div className="p-8 text-center text-[var(--ldr-text-muted)]">A carregar…</div>
        ) : items.length === 0 ? (
          <div className="p-12 text-center text-[var(--ldr-text-muted)]" data-testid="admin-contactos-empty">
            Ainda sem mensagens.
          </div>
        ) : (
          <ul className="divide-y divide-[var(--ldr-border)]">
            {items.map((c) => {
              const isOpen = expanded[c.id];
              return (
                <li key={c.id} className="p-5" data-testid={`contact-${c.id}`}>
                  <div className="flex items-start justify-between gap-4">
                    <button
                      type="button"
                      className="text-left flex-1"
                      onClick={() => setExpanded((e) => ({ ...e, [c.id]: !isOpen }))}
                      data-testid={`contact-toggle-${c.id}`}
                    >
                      <div className="flex items-center gap-2">
                        <span className="font-semibold text-[var(--ldr-text)]">{c.nome}</span>
                        <span className="text-[var(--ldr-text-muted)] text-sm">·</span>
                        <span className="text-sm text-[var(--ldr-text-muted)]">{formatDate(c.created_at)}</span>
                      </div>
                      <div className="mt-1 text-sm font-medium text-[var(--ldr-red)]">{c.assunto}</div>
                      <div className="mt-1 text-xs text-[var(--ldr-text-muted)]">
                        <Mail size={12} className="inline mr-1" />
                        {c.email}
                      </div>
                    </button>
                    <button
                      type="button"
                      onClick={() => toggleResolved(c.id)}
                      className={
                        "shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full border transition-colors " +
                        (c.resolvido
                          ? "bg-[#E9F5EC] text-[#1E6B33] border-[#C6E4CE] hover:bg-[#D9EEDF]"
                          : "bg-white text-[var(--ldr-text-muted)] border-[var(--ldr-border-strong)] hover:border-[var(--ldr-red)] hover:text-[var(--ldr-red)]")
                      }
                      data-testid={`contact-resolve-${c.id}`}
                    >
                      {c.resolvido ? <CheckCircle2 size={14} /> : <Circle size={14} />}
                      {c.resolvido ? "Resolvido" : "Marcar resolvido"}
                    </button>
                  </div>
                  {isOpen && (
                    <div className="mt-4 text-sm bg-[var(--ldr-bg-alt)] border border-[var(--ldr-border)] rounded-md p-4 whitespace-pre-wrap"
                         data-testid={`contact-message-${c.id}`}>
                      {c.mensagem}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" });
  } catch (_e) {
    return iso;
  }
}
